////get notification list///

import { GET_NOTIFICATION } from "./NotificationEndpoints";
import { instance } from "./instance";

export const getNotification = async () => {
    const result = await instance.get(GET_NOTIFICATION);
    return result;
  };